export const INITIAL = 'INITIAL';
export const SAVING = 'SAVING';
export const LOADING = 'LOADING';
export const READY = 'READY';
